export const COMMON_VAR = [
  "id",
  "name",
  "_position",
  "templateId",
  "finalImage",
  "uuid",
  "dataObjects",
  "typeUser",
  "clientId",
  "folderId",
  "createdAt",
  "updatedAt",
];
export const POST = [
  "id",
  "name",
  "width",
  "height",
  "_position",
  "templateId",
  "finalImage",
  "uuid",
  "dataObjects",
  "typeUser",
  "clientId",
  "folderId",
  "createdAt",
  "updatedAt",
];
export const ADDON = [
  "title",
  "description",
  "message",
  "logo",
  "styles",
  "addon_type",
];
export const FOLDER = ["id", "name", "type"];
